import {
  Project,
  ProjectFileUpload,
  ProjectModel,
  ProjectVirtualGraph,
} from 'src/store/state/projects';
import { replaceInvalidIriChars } from 'src/utils/removeInvalidIriChars';
import { replaceInvalidNameChars } from 'src/utils/removeInvalidNameChars';

const getDefaultProjectPrefix = (project: Pick<Project, 'name'>) =>
  `urn:${replaceInvalidIriChars(project.name)}:`;

// project.model.namespace
export const getDefaultProjectModelPrefix = (project: Pick<Project, 'name'>) =>
  `${getDefaultProjectPrefix(project)}`;

// project.dataNamespace (to be combined with class name)
export const getDefaultProjectDataPrefix = (project: Pick<Project, 'name'>) =>
  `${getDefaultProjectPrefix(project)}`;

export const generateModelConceptIri = (
  model: Pick<ProjectModel, 'namespace'>,
  label = ''
) => `${model.namespace}${replaceInvalidIriChars(label)}`;

export const generateModelNamedGraph = (
  project: Pick<Project, 'name'>,
  model: Pick<ProjectModel, 'name'>
) => `${getDefaultProjectPrefix(project)}${replaceInvalidIriChars(model.name)}`;

export const generateFileUploadNamedGraph = (
  project: Pick<Project, 'name'>,
  fileUpload: ProjectFileUpload
) =>
  `${getDefaultProjectPrefix(project)}${replaceInvalidIriChars(
    fileUpload.name
  )}`;

export const generateVirtualGraphName = (
  project: Pick<Project, 'name'>,
  virtualGraph: ProjectVirtualGraph
) =>
  `${replaceInvalidNameChars(project.name)}__${replaceInvalidNameChars(
    virtualGraph.dataSourceId
  )}`;
